// extracted by mini-css-extract-plugin
export default {"container":"AgeList_container__zvHDH","list":"AgeList_list__6PYVv"};